<template >
    <div v-bind:class="[showContainer==true ? 'container-fluid' : '']" v-if="lesson">

      <div class="card shadow mb-4" v-if="topic && item">
        <div class="card-header py-3">
          <div class="row">

              <div class="col">
                <h4 class="m-0 font-weight-bold text-primary">{{topic.name}} / {{item.name}}</h4>
                <p>Товч нэр: {{item.shortname}}</p>
              </div>
              <div class="col-auto">
                <small v-if="item.type!=null && item.type!=undefined">
                  <span>{{getType(item.type)}}</span>
                </small>
                <small class="ml-2">
                      <i class="fas fa-edit text-danger" @click="_editContent(item,topic)" ></i>
                </small>

              </div>


          </div>
        </div>
        <div class="card-body" >


            <div v-if="item">
              <div class="d-flex w-100 justify-content-between">
                
              </div>
              <p class="mb-1">{{item.description}}</p>
              <p class="mb-1" v-if="item.duration!=null">Үргэлжлэх хугацаа :{{item.duration}} минут</p>
      
              <div class="my-3">
                <span class="d-flex">
                  <div v-if="item.announcement==true" style="cursor:pointer" @click="setPropContent(false,topic, item, 'announcement')"><span class="badge badge-success">Зарлал болгосон</span></div>
                  <div v-else @click="setPropContent(true,topic, item, 'announcement')" style="cursor:pointer"><span class="badge badge-danger">Зарлал болгоогүй</span></div>
                  <span class="ml-2 d-flex" v-if="item.announcement==true">
                    <div v-if="item.open==true" style="cursor:pointer" @click="setPropContent(false,topic, item, 'open')"><span class="badge badge-success">Зарлал нээлттэй</span></div>
                    <div v-else @click="setPropContent(true,topic, item, 'open')" style="cursor:pointer"><span class="badge badge-danger">Зарлал хаалттай</span></div>
                  </span>
                </span>
               
                
              </div>

              <p class="mb-1" v-if="item.startDay!=null">Эхлэх: {{item.startDay | formatDate}}</p>
              <p class="mb-1" v-if="item.endDay!=null">Дуусах: {{item.endDay | formatDate}}</p>
              
              <!-- <button @click="$router.push({ name: 'DetailQuestions', params: { lessonId: lesson.id, topicId: topic.id, detailId: item.id} })" class="btn btn-danger my-3 btn-sm" v-if="item.type!=null && item.type!=undefined && item.type=='exam'">Шалгалтын асуулт бэлдэх</button>
              
              <button @click="$router.push({ name: 'DetailQuestions', params: { lessonId: lesson.id, topicId: topic.id, detailId: item.id} })" class="btn btn-danger my-3 btn-sm" v-if="item.type!=null && item.type!=undefined && item.type=='test'">Тестын  асуулт бэлдэх</button> -->
              <ul>
                <li style="margin-bottom: 18px;"  v-if="item.videoUrl!=null">
                  <p>Хэрэв таны видео зөв орсон бол доор шууд харагдана.</p>
                  <a v-bind:href="item.videoUrl" target="blank">  {{ item.videoUrl }} </a>
                  <br/>

                  <iframe width="560" height="315" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe>
                
                </li>
                <li  v-if="item.files!=null && item.files.length>0">
                  <div>
                      <div v-for="(file, index) in item.files" v-bind:key="file.id" v-if="validFile(file)">
                        <a v-bind:href="file.fileUrl" target="_blank"><i class="fas fa-download"></i> {{file.fileName}}</a>
                        <i class="fas fa-trash text-danger ml-2" @click="_deleteTopicFile(topic,item, file, index)"></i>
                      </div>
                  </div>
                </li>
              </ul>
              <input type="file" :ref="'file_' + item.id" @change="uploadFile(topic, item)">
              <div v-if="item.files==null || (item.files!=null && item.files.length==0) " class="my-2 alert alert-info">Та {{item.name}} агуулгын материалыг /ppt, pptx, docx, doc болон pdf файл/ оруулах боломжтой.</div>
              
              <div class="progress" v-if="item.uploading">
                <div class="progress-bar" role="progressbar" v-bind:style="{ width: item.uploadPercent + '%' }" aria-valuemin="0" aria-valuemax="100">{{item.uploadPercent.toFixed()}}%</div>
              </div>

              <div class="btn btn-primary btn-sm" @click="openSubContentModal">нэмэх</div>
              <div >
                <ul v-if="itemDetails!=null && itemDetails.length>0">
                  <li v-for="subdetail in itemDetails">
                    {{subdetail.data().name}}({{subdetail.data().numberOfUnderstand}})
                    <i class="fas fa-edit text-danger" @click="_editSub(subdetail)" ></i>
                  </li>
                </ul>
              </div>


            </div>

        </div>
      </div>
      <hr class="mb-5"/>
      
      <!-- ContentModal -->
      <div class="modal fade" id="contentModal" tabindex="-1" role="dialog" aria-labelledby="contentModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Агуулга нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="content">
              <form class="user">
                <div class="form-group">
                  <label>Агуулгын нэр: </label>
                  <input v-model.trim="content.name" class="form-control" placeholder="Агуулгын нэр">
                </div>
                <div class="form-group">
                   <label>Агуулгын товч нэр: </label>
                  <input v-model.trim="content.shortname" class="form-control" placeholder="Агуулгын товч нэр /VA, VariantB/">
                </div>
                <div class="form-group">
                  <label>Агуулгын дэлгэрэнгүй тайлбар: </label>
                  <textarea rows="10" v-model.trim="content.description" class="form-control"  placeholder="Агуулгын дэлгэрэнгүй"/>
                </div>
                <div class="form-group">
                  <label>Youtube видеоны линк: </label>
                  <input v-model.trim="content.videoUrl" class="form-control" placeholder="Видеоны линк">
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Агуулгын төрөл: </label>
                  <select class="form-control" v-model="selectedType" >
                    <option v-for="(type) in types" v-bind:key="type.id" v-bind:value="type.id">{{type.title}}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Эхлэх: </label>
                  <input v-model="content.startDayStr" class="form-control" placeholder="Агуулга нээгдэх хугацаа" type="datetime-local">
                </div>
                <div class="form-group">
                  <label>Дуусах: </label>
                  <input v-model="content.endDayStr" class="form-control" placeholder="Агуулга дуусах хугацаа" type="datetime-local">
                </div>
                 <div class="form-group">
                  <label>Агуулгын үргэлжлэх хугацаа/мин/: </label>
                  <input v-model.number="content.duration" class="form-control" type="number" placeholder="Агуулгын үргэлжлэх хугацаа">
                </div>
     

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveContent(selectedTopic)" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="submodal" tabindex="-1" role="dialog" aria-labelledby="submodalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="sub">
              <form class="user">
                <div class="form-group">
                  <label>нэр: </label>
                  <input v-model.trim="sub.name" class="form-control" placeholder="нэр">
                </div>
              
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveSubContent(sub)" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import LessonHeader from './LessonHeader'

export default {
    name: "ContentDetail",
    components:{
      LessonHeader
    },
    data() {
        return {
            lesson: null,
            topic:null,
            item:null,
            types:[],
            selectedType:null,
            content:{

            },
            itemDetails:[],
            selectedTopic:null,

            display:0,
            topicBucket:'lessonTopicFiles/',
            sub:{
              "name":null
            }
            
        };
    },
    methods: {
        
      _getQA(){

        fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
            let lesson=doc.data();
            lesson.id=doc.id;
            this.lesson=lesson;
            doc.ref.collection("topics").doc(this.topicId).get().then(tdoc=>{
              if(tdoc.exists){
                let topic=tdoc.data();
                topic.id=tdoc.id;
                this.topic=topic;

                tdoc.ref.collection("details").doc(this.contentId).onSnapshot(cdoc=>{
                  if(cdoc.exists){
                    let item=cdoc.data();
                    item.id=cdoc.id;
                    item.uploading=false;
                    item.uploadPercent=0;
                    this.item=item;

                    cdoc.ref.collection("subdetails").orderBy("createdAt", "desc").onSnapshot(docs=>{
                      if(docs!=null && !docs.empty){
                        this.itemDetails=docs.docs;
                      }
                    });
                  }
                });
              }
            });
          
        });

          fb.db.collection("ContentTypes").get().then(querySnapshot=> {
              this.types=[]
              querySnapshot.forEach(doc=> {
                let object=doc.data()
                object.id = doc.id
                object.content=[]
                this.types.push(object);
              });
            
          });

      },
      saveContent(topic) {
        if(this.content!=null && this.content.name!=null && this.content.name!='' && this.selectedType!=null){
          if(this.content.videoUrl!=null && this.content.videoUrl!='' ){
            if (this.content.videoUrl.toLowerCase().indexOf("youtube") == -1) {
              alert("Та заавал youtube бичлэг оруулна уу");
              return;
            }
          }
          this.content.typeRef=fb.db.collection("ContentTypes").doc(this.selectedType);
          this.content.type=this.selectedType;
        
          if(this.lesson!=null && this.topic!=null && this.topic.id!=null && this.content!=null && this.content!=undefined){

              if(this.content.startDayStr!=null && this.content.startDayStr!=''){
                this.content.startDay=new Date(this.content.startDayStr);
              }

              if(this.content.endDayStr!=null && this.content.endDayStr!=''){
                this.content.endDay=new Date(this.content.endDayStr);
              }
                  
              if(this.selectedType!=null && this.selectedType=="exam"){
                this.content.roundCount=1;
              }
              else if(this.selectedType!=null && this.selectedType=="test"){
                this.content.roundCount=10;
              }

              if(this.content.id!=undefined && this.content.id!=null && this.content.id!='' && this.content.id!='new'){
                this.content.modifiedAt=new Date();
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.content.id).update(this.content)
              }
              else{
                this.content.createdAt=new Date();
                this.content.code=new Date().getTime().toString();
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc().set(this.content)
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).update({
                  'numberOfContent':fb.firestore.FieldValue.increment(1)
                });

                fb.db.collection("lessons").doc(this.lessonId).update({
                  'numberOfContent':fb.firestore.FieldValue.increment(1)
                });
                
                if(this.content.videoUrl!=null && this.content.videoUrl!=''){
                  fb.db.collection("lessons").doc(this.lessonId).update({
                    'numberOfVideos':fb.firestore.FieldValue.increment(1)
                  });
                }

              }
              

              this.selectedType=null;
              this.selectedTopic=null;
              this.content={
                'name':null,
                'description':null,
                'videoUrl':null,
                'published':false,
                'startDay':null,
                'endDay':null,
                'code':null,
                'duration':null,
                'shortname':null
              }
    
          }
          $('#contentModal').modal('hide');
        }
        else{
          alert("Та талбаруудыг гүйцэд бөглөнө үү");
        }
      },
      saveSubContent(sub){
        if(sub!=null && sub.name!=null && sub.name!=''){

        
          if(this.lesson!=null && this.topic!=null && this.topic.id!=null && this.item!=null && this.item!=undefined){
              if(sub.id!=undefined && sub.id!=null && sub.id!='' && sub.id!='new'){
                sub.modifiedAt=new Date();
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id).collection("subdetails").doc(sub.id).update(sub);
              }
              else{
                sub.createdAt=new Date();
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id).collection("subdetails").doc().set(sub);
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id).update(
                  { "numberOfSubdetails": fb.firestore.FieldValue.increment(1) }
                );
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).update(
                  { "numberOfSubdetails": fb.firestore.FieldValue.increment(1) }
                );
                fb.db.collection("lessons").doc(this.lessonId).update(
                  { "numberOfSubdetails": fb.firestore.FieldValue.increment(1) }
                );
              }
              
              this.sub={
                'name':null
              }
    
          }
          $('#submodal').modal('hide');
        }
        else{
          alert("Та талбаруудыг гүйцэд бөглөнө үү");
        }
      },
      openSubContentModal(){
        this.sub={name:null};
        $('#submodal').modal('show');

      },
      _editSub(subdetail){
        this.sub={
          id: subdetail.id,
          name: subdetail.data().name
        };
        $('#submodal').modal('show');
      },
      openSaveContentModal(topic){
        this.selectedTopic=topic;
        $('#contentModal').modal('show');

      },

      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { lessonId: this.lessonId, type: type.id, topicId: topic.id} })
      },


 
      _editContent(content, topic){
          this.content= Object.assign({}, content);
          this.selectedType=content.type;
          $('#contentModal').modal('toggle');
      },


      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },

      setPublished(value, lesson){
        this.setProperty("published", fb.db.doc("lessons/"+lesson.id), value);
        if(value==true){
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});

          var publish = firebase.functions().httpsCallable('publishLesson');
          publish(
            { lessonId: lesson.id}
          );
        }
        else{
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          var unpublish = firebase.functions().httpsCallable('unPublishLesson');
          unpublish(
            { lessonId: lesson.id}
          );
        }
      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      uploadFile(topic, content){
        var _this=this;

        var files = this.$refs['file_'+content.id].files;
        if(files!=null && files.length>0){
          var file=files[0];
          if(file.name.endsWith("mp4") 
            || file.name.endsWith("MP4") 
            || file.name.endsWith("MPEG") 
            || file.name.endsWith("mov") || file.name.endsWith("MOV")
            || file.name.endsWith("webm") || file.name.endsWith("WEBM")
          )
          {
            alert("Та video файл оруулах боломжгүй");
            return;
          }
          var now=new Date();
          var fileName=this.topicBucket+"_" +now.getTime()+"_"+file.name;
          var uploadTask = fb.storageRef.child(fileName).put(file);
          content.uploading=true
          content.uploadPercent=0
          uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              content.uploadPercent=progress
            }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                break;

              case 'storage/canceled':
                break;
              case 'storage/unknown':
                break;
            }
          }, 
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              
              let fileObject={
                'fileName': fileName,
                'fileUrl':downloadURL,
                'realName': file.name,
                'uploadedAt': now
              }
              fb.db.collection("lessons").doc(_this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id).update(
                {
                    files: fb.firestore.FieldValue.arrayUnion(fileObject)
                }
              )
              content.uploading=false
              content.uploadPercent=0
             
            });
          });
        }
        
      },
      _deleteTopicFile(topic,content, file, index){
        var result = confirm("Та "+file.fileName+" файлыг устгах уу?");
          if (result) {
            var fileName=file.fileName;
            var fileRef = fb.storageRef.child(fileName);
            fileRef.delete();
              content.files.splice(index, 1)
              fb.db.collection("lessons").doc(this.lessonId).collection("topics/"+topic.id+"/details").doc(content.id).update({
                  files: content.files
                }
              );
              
          }
      }
      ,
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return 'https://www.youtube.com/embed/' + id ;
        }
        return null;
      },
      getType(type){
        if(type=="test")
          return "Тест";
        else if(type=="video")
          return "Видео хичээл";
        else if(type=="lecture")
          return "Лекц";
        else if(type=="seminar")
          return "Семинар";
        else if(type=="exam")
          return "Шалгалт";
        else if(type=="homework")
          return "Гэрийн даалгавар";
        else if(type=="coursework")
          return "Бие даалт";
        
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        lessonId: { 
            required: true,
        },
        topicId:{
          required:true
        },
        contentId:{
          required:true
        } ,
        showContainer:{
          required:false
        }
    },
    created() {
        var _this=this;
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

